import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { BaseCard, CustomImageView } from '../commonComponents';

type iProps = {
    isModal: boolean,
    toggleModal: () => void,
    type?: string,
    signObj?: {
        type: string,
        name: string,
        signature: {
            fileName: string,
            url: string
        },
    }
}

const SignatureViewModal: React.FC<iProps> = ({ isModal, toggleModal, signObj, type }) => {

    return (
        <Modal 
            isOpen={isModal} 
            toggle={toggleModal} 
            backdrop={true} 
            scrollable={true}
            fade={false}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            <ModalHeader toggle={toggleModal} >Signature</ModalHeader>
            <ModalBody className='pd-b-15'>
                <BaseCard customBaseCardStyle='rounded-3 pd-15 h-200 mg-t-10'>
                    <CustomImageView
                        url={signObj?.signature?.url ?? ''}
                        resizeMode='contain'
                        loaderSize={25}
                        customImageStyles='h-100 w-100'
                    />
                </BaseCard>
                <div className='form-group mg-t-20'>
                    <div className='form-label text-gray-300 mb-1 fs-12'>{type}</div>
                    <div className='form-control read-only-control d-flex align-items-center'>{signObj?.name}</div>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default SignatureViewModal;